
import makerjs from "makerjs";
function C33(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,R1 = Param[1].param, R2 = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       r1 = R1 * 1 * myZoom,
       r2 = R2 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       /**
        * 已知弦长、半径求拱高
        * H=R-Math.sqrt((R*R)-((L*L)/4))
        */
       h1=r1-Math.sqrt((r1*r1)-((w*w)/4)),
       h2=r2-Math.sqrt((r2*r2)-((w*w)/4)),
       h=h1+h2,
       rd1=h1/Math.sqrt(2),
       rd2=h2/Math.sqrt(2),
       x0 = 0, x1 = w,  y0 = 0, y1 = 0, glassH = h, glassW = w;

   if (r1 !== 0) {
       var TxtR1= "R1="+R1;
   } if (R2 !== 0) {
  var TxtR2 = "R2="+R2;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeC33 = {
       paths: {
        "TopArcLine": new makerjs.paths.Arc([x0, y0], [x1, y1],r2,false,true), 
        "BottomArcLine": new makerjs.paths.Arc([x1,y1], [x0, y0],r1,false,true),
       }
   };
   var drawAbnormalShapeC33MarkR1 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([w/2, -h1], [w/2-rd1, -h1+rd1]),
       }
   };
   var drawAbnormalShapeC33MarkR2 = {
       paths: {
        "RightLine": new makerjs.paths.Line([w/2, h2], [w/2+rd2, h2-rd1]),
       }
   };
   var drawAbnormalShapeC33MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 -h1- markShift], [x1, y1-h1 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0-h1], [x0, y0-h1 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x1, y1-h1], [x1, y1-h1 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeC33MarkW, TxtW, [x0, y0 -h1- 2*markShift], [x1, y1-h1 - 2*markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeC33MarkR2, TxtR2, [w/2+rd2-3*markShift, h2-rd1-markShift], [w/2+rd2+3*markShift, h2-rd1-markShift]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeC33MarkR1, TxtR1, [w/2-rd1-3*markShift, -h1+rd1+markShift],[w/2-rd1+3*markShift, -h1+rd1+markShift]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeC33: drawAbnormalShapeC33,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC33: drawAbnormalShapeC33,
        drawAbnormalShapeC33MarkR1: drawAbnormalShapeC33MarkR1,
        drawAbnormalShapeC33MarkR2:drawAbnormalShapeC33MarkR2,
        drawAbnormalShapeC33MarkW:drawAbnormalShapeC33MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C33;